// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"672":"component---src-pages-test-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"672":"5d0677f15372b8a055da","678":"d30006e6ebbcc50e5df3","883":"b56062ac6b09924d0416"}[chunkId] + ".js";
};